import type { HTMLComponent } from "@commercekit/react";
import WvRelatedProductItem from "../molecules/WvRelatedProductItem";
import type { WovarCustomer, WovarProduct } from "@commercekit/api";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";

const WvRelatedProducts: HTMLComponent<{
  products: WovarProduct[];
  customer: WovarCustomer;
}> = ({ products, customer }) => {
  const { $pt } = usePrismicLabels();

  return (
    <section className="pdp__related">
      <h2 className="heading sans-serif md strong underlined left pb-3 mb-3">
        {$pt("product_label_related_products")}
      </h2>

      <div className="row-scroller-mobile mx-n3 mx-md-0 pl-3 pl-md-0 mb-3">
        <div className="row mx-n3 mx-md-n2 px-2 px-md-0 no-gutters justify-content-start pb-3">
          {products?.map((item, i) => {
            if (!item) return null;
            return (
              <WvRelatedProductItem
                product={item}
                key={`${item?.id}_${i}`}
                itemListId="related_product"
                itemListName="Related Product"
                customer={customer as WovarCustomer}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WvRelatedProducts;
